import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-frontend-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
  standalone: true,
})
export class SpinnerComponent {
  @Input()
  text: string;

  constructor() {
    this.text = '';
  }
}
